// from general.js
/* global readCookie createCookie dcAnalytics qsParam isMobileView toggleSignInOverlay
getURLParam  */
// from JSP?
/* global fullyFunded progressBarPercentage proposalId teacherScreenName teacherId hideTeacherDetails
photosPublished isApplePayEnabled isApplePayMobileOnly */
// from Stripe third-party script
/* global Stripe */

// imports for doc listeners
import '../faq/faq.js';
import '../sharebar/shareBarOnClickHandlers.js';
import './teacherProfilePhoto.js';
import './addRFParamForTeacher.js';
import './autofillDonationAmount.js';
import './CartCopy.js';
import './trackProjectPageStatus.js';
import './toggleSections.js';
import './projectPageContext.js';
import './targetSupportedProject.js';
import '../projectpage-react/projectPageReactMain.js';

import { checkIsApplePayAvailable } from '../common/applePayUtils.js';
import { initSharebarTwitterAndSMSForProjectPage } from '../sharebar/sharebarHelperFunctions.js';
import { getDonateOptions } from './giveWidgetOverrides.js';
import { userCanSeeImpactPhotos } from './proposalMessage.js';
import { checkDonationAmount, validateInspireForm } from '../giveWidget/giveWidgetFunctions.js';


$(document).ready(function () {
    if (readCookie('xAPBanner') == null) {
        try {
            const stripe = Stripe(stripePublishableAPIKey);
            checkIsApplePayAvailable(isApplePayEnabled, isApplePayMobileOnly, stripe.paymentRequest, displayApplePayCallout);
        } catch (e) {
            console.warn('Could not display the Apple Pay callout.');
        }
    }

    moveProposalSupportingDetails();

    initSharebarTwitterAndSMSForProjectPage();

    // IF THE URL HAS MMI EMAIL TRACKING PARAMS, RECORD AN EVENT IN GOOGLE ANALYTICS
    if (qsParam.utm_campaign != null && qsParam.utm_campaign.substring(0, 4) === 'mmi_') {
        if (fullyFunded === 'true') {
            dcAnalytics.trackEventGANonInteraction(['Project Page', 'MMiEmail', 'Completed']);
        } else {
            dcAnalytics.trackEventGANonInteraction(['Project Page', 'MMiEmail', 'Live']);
        }
    }

    displaySchoolDetails();

    window.pmaId = qsParam.pmaId;
    window.pmaHash = qsParam.pmaHash;
    window.queryString = window.location.search.substring(1);
    checkTeacherBirthday();
    $('.js-progress-bar-span').css('width', progressBarPercentage.toString() + '%');
    $('.js-donate-bar-standard').on('click', getDonateOptions);
    $('.js-instant-fundraising-donate-button').on('click', getDonateOptions);
    $('.js-signin-link').on('click', (e) => {
        toggleSignInOverlay(e);
        if (!isMobileView()) {
            window.scrollTo(0, 0);
        }
    });
    $('.js-donate-form').on('submit', () => { checkDonationAmount($('.js-donate-form')[0]); });
    $('.js-classroom-photo-format-retina-bg').on('click', () => { dcAnalytics.trackEventGA([pageName, 'Classroom Photo', 'Teacher Search']); });
    $('.js-teacher-link').on('click', () => { dcAnalytics.trackEventGA([pageName, 'Tab 1', 'Teacher Search']); });
    $('.js-inspire-form').on('submit', () => { return validateInspireForm($('.js-inspire-form')[0]); });
    $('.js-suggested-amount-to-complete').on('click', () => { dcAnalytics.trackEventGA([pageName, 'give expanded', 'complete button - desktop']); });
    $('.js-hide-apple-pay-banner').on('click', hideAPBanner);
});

function hideAPBanner() {
    createCookie('xAPBanner', 'true', 90);
    $('#js-apple-pay-callout').hide();
}

$(window).on('orientationchange resize', function () {
    moveProposalSupportingDetails();
});

function checkTeacherBirthday() {
    if ($('.js-birthday-banner').length > 0) {
        dcAnalytics.track('Birthday Banner', {
            projectId: proposalId,
            teacherId: teacherId,
            teacherScreenName: teacherScreenName,
        });
        dcAnalytics.trackEventGANonInteraction([pageName, 'Birthday Banner', teacherId]);
    }
}

// move proposal-supporting-details to the right place
function moveProposalSupportingDetails() {
    if (isMobileView()) {
        $('#proposal-supporting-details-mobile').append($('#proposal-supporting-details'));
    } else {
        $('#proposal-supporting-details-desktop').append($('#proposal-supporting-details'));
    }
}

// only display school name and address if impact photos is available and the current user can see impact photos
function displaySchoolDetails() {
    const verifyShowPhotosParamIncluded = getURLParam(location.href, 'verifyShowPhotos');
    const showStateOnly = hideTeacherDetails || verifyShowPhotosParamIncluded || (photosPublished && userCanSeeImpactPhotos());
    if (showStateOnly) {
        $('#school-details-all').remove();
        $('#school-details-state-only').css('display', 'block');
    } else {
        $('#school-details-all').css('display', 'block');
        $('#school-details-state-only').remove();
    }
}

function displayApplePayCallout() {
    $('#js-apple-pay-callout').show();
    dcAnalytics.track('Apple Pay banner shown');
}
